// Browser side of the signed success return (server: src/api/monri-return.ts).
// The result pages hand the URL they were opened with to the server, which
// verifies Monri's digest and confirms the payment even if the callback never
// came. The exact href matters: the digest covers the raw query string.

const SIGNED_RETURN_RE = /[?&]digest=[a-f0-9]{128}(?:[&#]|$)/;

export function isSignedMonriReturn(href: string): boolean {
  return SIGNED_RETURN_RE.test(href);
}

/** True when the server accepted the return; never throws. */
export async function confirmMonriReturn(href: string, fetchImpl: typeof fetch = fetch): Promise<boolean> {
  try {
    const res = await fetchImpl("/api/monri/return", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: href }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
